import { render, staticRenderFns } from "./app-push.vue?vue&type=template&id=55671cd8&scoped=true&"
import script from "./app-push.vue?vue&type=script&lang=js&"
export * from "./app-push.vue?vue&type=script&lang=js&"
import style0 from "./app-push.vue?vue&type=style&index=0&id=55671cd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55671cd8",
  null
  
)

export default component.exports